var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatternGraphicDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 192,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#552049",
    d: "M0 0h64v128H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF7F0",
    strokeWidth: 4,
    cx: 32,
    cy: 32,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 32)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6A560",
    x: 32,
    width: 64,
    height: 32,
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61C4B7",
    d: "m0 128 32 32v-32zM32 96l32 32V96z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF7F0",
    strokeWidth: 4,
    cx: 80,
    cy: 16,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF7F0",
    strokeWidth: 4,
    cx: 80,
    cy: 16,
    r: 14
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 14h4v4h-4zM68 14h4v4h-4zM92 14h4v4h-4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#755CDE",
    d: "m96 0 32 32V0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 14h4v4h-4zM120 14h4v4h-4zM124 14h4v4h-4z"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#030303",
    strokeWidth: 4,
    cx: 80,
    cy: 80,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB7565",
    d: "M96 64h32v32H96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7F0",
    d: "m32 96 96 96V96z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 128h4v4H0zM14 128h4v4h-4zM28 128h4v4h-4zM0 142h4v4H0zM14 142h4v4h-4zM28 142h4v4h-4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 156h4v4H0zM14 156h4v4h-4zM28 156h4v4h-4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternGraphicDesign);
export default __webpack_public_path__ + "static/media/pattern-graphic-design.9a6e56bc8a173b7c4040c91151fd7670.svg";
export { ForwardRef as ReactComponent };